import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Content, Loader, MessageBox } from '../styles';
import { StyledMessage } from './styles';
import DeliveryStatus from '../../DeliveryStatus';
import LastErrorMessage from '../../LastErrorMessage';
import Avatar from '../../Avatar';
import ErrorMessage from '../../ErrorMessage';
import Typography from '@mui/material/Typography';
import { Link } from '@mui/material';

const ImageWithText = ({ client, message, resend, handleImagePopup, customerDataStoreTimezone, more = null }) => {
  return (
    <StyledMessage isClient={client} key={message?._id?.$oid + message?.sendId}>
      <Content>
        <MessageBox>
          {!message?.isClient && message?.lastSendError && (
            <IconButton aria-label="resend" onClick={() => resend(message?._id?.$oid)}>
              <RefreshIcon fontSize="small" />
            </IconButton>
          )}
          {(!message?.delivery ||
              message?.delivery === 'sending' ||
              message?.delivery === 'sent2api' ||
              message?.delivery === 'sent_to_api') &&
            !client && <Loader color="primary" src={'/img/loader-new.gif'} />}
          {/*<ImgContainer onClick={() => handleImagePopup(message?.body?.image?.url)}>*/}
          {message?.body?.image?.url ? (
            <>
              <Avatar message={message} isClient={client} />
              <img
                src={message?.body?.image?.url}
                alt={message?.body?.image?.text || ''}
                onClick={() => handleImagePopup(message?.body?.image?.url)}
              />
              <Typography sx={{width: '100%'}}>{message?.body?.title || ''}</Typography>
              <Typography sx={{width: '100%'}}>{message?.body?.caption || ''}</Typography>
              <Typography sx={{width: '100%'}}>{message?.body?.text || ''}</Typography>
              <Typography sx={{width: '100%'}}>{message?.body?.link_url ? (
                <Link href={message?.body?.link_url || '#'} target="_blank">{message?.body?.link_url || '#'}</Link>
              ) : ('')}</Typography>
            </>
          ) : (
            ''
          )}
          {/*</ImgContainer>*/}
        </MessageBox>
        {more}
        <DeliveryStatus
          isClient={client}
          message={message}
          customerDataStoreTimezone={customerDataStoreTimezone}
        />
        <LastErrorMessage message={message} />
        <ErrorMessage message={message?.rawResponse?.process_msg ?? ''} />
      </Content>
    </StyledMessage>
  );
};

export default ImageWithText;
